import { lazy } from 'react'

export const SubscriptionsVariant1 = lazy(
  () => import('./SubscriptionsVariant1'),
)
